

const initialState = {
    booleanCreateModalIsOpen: false,
    booleanEditModalIsOpen: false,
    booleanDeleteModalIsOpen: false,
    booleanReviewModalIsOpen: false,
    booleanRetireModalIsOpen: false,
}
//We dispatched the createLecture in the lectureAction.js.  This file needs to detect the createLecture.
const createCourseReducer = (state = initialState, action) => {
    //detect the createLecture through the switch statements.

    
    switch (action.type) {

        case 'CREATE_CONTENT_COURSE':
            return state;
        
        case 'CREATE_CONTENT_COURSE_ERROR':
            return false;

        case 'EDIT_CONTENT_COURSE':
            return state;

        case 'EDIT_CONTENT_COURSE_ERROR':
            return state;

        case 'EDIT_ACTIVATED_COURSE':
            return state;

        case 'EDIT_ACTIVATED_COURSE_ERROR':
            return state;

        case 'CHANGE_COURSE_MODAL':
            return {
                ...state,
                booleanCreateModalIsOpen: action.booleanCreateModalIsOpen,
                booleanEditModalIsOpen: action.booleanEditModalIsOpen,
                booleanDeleteModalIsOpen: action.booleanDeleteModalIsOpen,
                booleanReviewModalIsOpen: action.booleanReviewModalIsOpen,
                booleanRetireModalIsOpen: action.booleanRetireModalIsOpen,
            }
            
        case 'DELETE_COURSE':
            return state;

        case 'DELETE_COURSE_ERROR':
            return state;


        case 'REVIEW_COURSE':
            return state;

        case 'REVIEW_COURSE_ERROR':
            return state;

        default:
            return state;
    }
    
   

}

//This information gets sent over to the "rootReducer" and stored on a "course" state.
export default createCourseReducer
